import { FIELDS_ICON_MAPPER } from "../../../../constants/fields-icon.constant";

function ReadonlyCustomFields({ item, customFieldCanvasRef, disableEdit }) {
    return (
        <>
            <div className="tile__content">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center text-black">
                        <i style={{
                            backgroundColor: 'lightgrey',
                            color: 'black',
                            borderRadius: '2px',
                            fontSize: '0.8rem',
                            opacity: 1
                        }} className={`fa-solid me-2 p-2 ${FIELDS_ICON_MAPPER[item?.field_type] ? FIELDS_ICON_MAPPER[item?.field_type] : 'fa-tag'}`}></i>
                        <div>
                            <p>{item.field_label}</p>
                        {item?.field_is_required ? <p className='text-muted f-12-small mb-0'>Required</p> : ''}
                        </div>
                    </div>
                    {
                        !disableEdit ?
                            <button onClick={customFieldCanvasRef?.current?.handleShow} type="button" className="btn btn-outline-primary mb-0">
                                Edit
                            </button> : ''
                    }
                    
                </div>
            </div>
        </>
    );
}

export default ReadonlyCustomFields;